export const frContent = {
  introduction: {
    content: [
      "Depuis ses débuts en 1996, la série Pokémon a conquis les cœurs du monde entier, devenant l'une des marques de divertissement les plus appréciées au niveau mondial. Notre Générateur Aléatoire de Pokémon est conçu pour les dresseurs de tous âges qui souhaitent découvrir de nouveaux Pokémon, constituer des équipes équilibrées ou simplement profiter de l'élément de surprise dans leur voyage Pokémon.",
      "Que vous soyez un dresseur chevronné à la recherche d'inspiration pour votre prochaine équipe de tournoi ou un fan occasionnel cherchant à compléter son Pokédex, cet outil de génération aléatoire de Pokémon offre une façon amusante et interactive d'explorer le vaste monde des Pokémon."
    ]
  },
  howToUse: {
    content: [
      "L'utilisation de notre Sélecteur Aléatoire de Pokémon est simple et intuitive. Suivez ces étapes pour commencer à générer votre équipe Pokémon parfaite :",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Sélectionnez le nombre de Pokémon : Choisissez combien de Pokémon vous souhaitez générer (1-8)." },
          { type: "text", content: "Choisissez un Type : Filtrez par types spécifiques comme Feu, Eau, Électrik, ou sélectionnez \"Tous\" pour inclure tous les types." },
          { type: "text", content: "Sélectionnez une Génération : Choisissez de la Génération I à VIII, ou sélectionnez \"Toutes\" pour inclure les Pokémon de toutes les générations." },
          { type: "text", content: "Définissez les préférences de Rareté : Déterminez la rareté souhaitée pour vos Pokémon générés." },
          { type: "text", content: "Cliquez sur \"Générer\" : Une fois vos préférences définies, cliquez sur le bouton pour générer des Pokémon correspondant à vos critères." },
          { type: "text", content: "Explorez les Résultats : Examinez les informations détaillées de chaque Pokémon, y compris les statistiques, les capacités, les types et plus encore !" }
        ]
      },
      "Vous pouvez répéter ce processus autant de fois que vous le souhaitez, en ajustant vos paramètres pour découvrir différentes combinaisons de Pokémon."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Totalement Gratuit : Notre Générateur Aléatoire de Pokémon est 100% gratuit, sans frais cachés ni abonnement." },
          { type: "text", content: "Expérience Personnalisable : Filtrez par type, génération et rareté pour personnaliser vos sélections aléatoires." },
          { type: "text", content: "Outil Éducatif : Apprenez-en plus sur les différentes espèces de Pokémon, leurs statistiques, capacités et types." },
          { type: "text", content: "Construction d'Équipe : Générez rapidement des équipes équilibrées pour le jeu occasionnel ou les combats compétitifs." },
          { type: "text", content: "Créateur de Défis : Créez des défis uniques en vous limitant aux Pokémon générés aléatoirement." },
          { type: "text", content: "Pas de Compte Requis : Utilisez l'outil instantanément sans inscription ni informations personnelles." }
        ]
      }
    ]
  },
  history: {
    content: [
      "La franchise Pokémon a débuté en 1996 lorsque Satoshi Tajiri a créé les premiers jeux Pokémon pour la Game Boy de Nintendo. Inspiré par son passe-temps d'enfance de collection d'insectes, le concept s'est centré sur la capture, l'entraînement et les combats avec des créatures appelées \"Pocket Monsters\" ou Pokémon.",
      "Les moments clés de l'histoire de Pokémon incluent :",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996 : Sortie de Pokémon Rouge et Vert au Japon" },
          { type: "text", content: "1998 : Sortie internationale de Pokémon Rouge et Bleu" },
          { type: "text", content: "1999 : Lancement mondial du Jeu de Cartes à Collectionner Pokémon" },
          { type: "text", content: "2000 : Introduction de Or et Argent, ajoutant 100 nouveaux Pokémon" },
          { type: "text", content: "2016 : Sortie de Pokémon GO, amenant la franchise sur les plateformes mobiles" },
          { type: "text", content: "2019 : Début de Pokémon Épée et Bouclier sur Nintendo Switch" }
        ]
      },
      "Aujourd'hui, avec plus de 900 espèces différentes de Pokémon à travers huit générations, la franchise s'est étendue pour inclure des jeux vidéo, des cartes à collectionner, des séries animées, des films, des produits dérivés et des applications mobiles, en faisant l'une des franchises médiatiques les plus rentables de tous les temps."
    ]
  },
  popularPokemon: {
    content: [
      "Tout au long de l'histoire de Pokémon, plusieurs espèces sont devenues des symboles emblématiques de la franchise :",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu : La mascotte de type Électrik de la franchise, connue pour sa queue en forme d'éclair et ses joues roses." },
          { type: "text", content: "Dracaufeu : Un favori des fans de type Feu/Vol connu pour son apparence de dragon et ses puissantes capacités." },
          { type: "text", content: "Mewtwo : Un légendaire de type Psy créé par manipulation génétique de Mew, connu pour son immense puissance." },
          { type: "text", content: "Évoli : Adoré pour sa capacité unique à évoluer en différents types, notamment Aquali, Voltali et Pyroli." },
          { type: "text", content: "Léviator : Un redoutable type Eau/Vol qui évolue du modeste Magicarpe." },
          { type: "text", content: "Lucario : Un type Combat/Acier connu pour ses capacités à détecter l'aura et sa popularité en jeu compétitif." },
          { type: "text", content: "Amphinobi : Un Pokémon grenouille ninja de type Eau/Ténèbres qui a gagné en popularité grâce à la série animée." }
        ]
      },
      "Notre Générateur Aléatoire de Pokémon vous donne l'opportunité de découvrir ces créatures emblématiques et de nombreuses autres espèces moins connues mais tout aussi fascinantes."
    ]
  },
  popularGames: {
    content: [
      "La série de jeux Pokémon a produit de nombreux titres appréciés sur plusieurs plateformes :",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Rouge, Bleu et Jaune : Les jeux originaux qui ont lancé le phénomène sur Game Boy." },
          { type: "text", content: "Pokémon Or, Argent et Cristal : Ont introduit la région de Johto et les cycles jour/nuit." },
          { type: "text", content: "Pokémon Rubis, Saphir et Émeraude : Ont étendu le monde avec la région de Hoenn et les combats doubles." },
          { type: "text", content: "Pokémon Diamant, Perle et Platine : Ont amené la série sur Nintendo DS avec des fonctionnalités en ligne." },
          { type: "text", content: "Pokémon Noir et Blanc : Ont présenté un ensemble entièrement nouveau de Pokémon et une approche plus narrative." },
          { type: "text", content: "Pokémon X et Y : Ont introduit les modèles 3D et la Méga-Évolution." },
          { type: "text", content: "Pokémon Soleil et Lune : Ont réinventé le système des arènes avec les Épreuves des Îles." },
          { type: "text", content: "Pokémon GO : Le jeu mobile en réalité augmentée qui est devenu un phénomène mondial." },
          { type: "text", content: "Pokémon Épée et Bouclier : Ont amené la série sur Nintendo Switch avec le concept des Terres Sauvages." },
          { type: "text", content: "Légendes Pokémon : Arceus : Une nouvelle approche en monde ouvert pour la série." }
        ]
      },
      "Chaque jeu introduit de nouvelles mécaniques et Pokémon, élargissant l'univers que notre Générateur Aléatoire de Pokémon vous aide à explorer."
    ]
  },
  tradingContests: {
    content: [
      "L'échange de Pokémon a été un aspect fondamental de la franchise depuis ses débuts. Les jeux originaux ont été publiés par paires spécifiquement pour encourager les joueurs à échanger avec leurs amis pour compléter leur Pokédex. Cet élément social a contribué à répandre la popularité de Pokémon et reste important aujourd'hui.",
      "Les aspects clés des échanges incluent :",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Des Pokémon exclusifs à chaque version qui ne peuvent être obtenus que par échange" },
          { type: "text", content: "Des évolutions par échange pour certaines espèces comme Machopeur et Kadabra" },
          { type: "text", content: "Le Système d'Échange Global dans les jeux modernes permettant des échanges mondiaux" },
          { type: "text", content: "L'échange de Pokémon rares ou chromatiques comme symboles de statut" }
        ]
      },
      "Les Concours Pokémon, introduits dans la Génération III, offrent une alternative aux combats où les Pokémon rivalisent sur la base de leur apparence, performance et attrait plutôt que de leur force. Ces concours comprennent :",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Différentes catégories de concours (Sang-froid, Beauté, Grâce, Intelligence, Robustesse)" },
          { type: "text", content: "Des capacités spéciales conçues spécifiquement pour les concours" },
          { type: "text", content: "La gestion de la condition des Pokémon via les Baies et les Poffins" },
          { type: "text", content: "Des compétitions en plusieurs étapes avec des jugements visuels préliminaires et des tours de performance" }
        ]
      },
      "Notre Générateur Aléatoire de Pokémon peut vous aider à découvrir des Pokémon qui pourraient exceller dans les concours ou devenir de précieux partenaires d'échange, ajoutant une nouvelle dimension à votre expérience Pokémon."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Ce Générateur Aléatoire de Pokémon est-il gratuit ?",
            answer: "Oui, notre outil est entièrement gratuit sans coûts cachés ni exigences d'abonnement."
          },
          {
            type: "faq",
            question: "Les données Pokémon sont-elles précises ?",
            answer: "Toutes les données proviennent de la PokéAPI officielle, garantissant leur précision et leur mise à jour."
          },
          {
            type: "faq",
            question: "Puis-je générer des Pokémon d'une génération spécifique ?",
            answer: "Oui, vous pouvez filtrer par génération de I à VIII, ou choisir \"Toutes\" pour inclure toutes les générations."
          },
          {
            type: "faq",
            question: "Comment fonctionne le filtre de rareté ?",
            answer: "Notre algorithme attribue des valeurs de rareté basées sur des facteurs comme le statut légendaire/mythique, l'expérience de base et d'autres attributs pour créer une échelle de rareté de 1 à 10."
          },
          {
            type: "faq",
            question: "Puis-je sauvegarder ou exporter les Pokémon générés ?",
            answer: "Actuellement, vous pouvez faire des captures d'écran de vos résultats. Nous envisageons d'ajouter des fonctionnalités de sauvegarde/exportation dans de futures mises à jour."
          },
          {
            type: "faq",
            question: "Le Générateur Aléatoire de Pokémon est-il compatible avec les appareils mobiles ?",
            answer: "Oui, notre générateur est entièrement responsive et fonctionne sur smartphones, tablettes et ordinateurs de bureau."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Notre Générateur de Pokémon Aléatoire offre des possibilités infinies tant pour les fans occasionnels que pour les dresseurs dévoués. Que vous cherchiez à découvrir de nouveaux favoris, à créer des équipes thématiques ou à vous mettre au défi avec des combinaisons inattendues, notre outil propose une façon amusante et éducative d'explorer le vaste monde des Pokémon.",
      "Nous travaillons constamment à améliorer le générateur avec de nouvelles fonctionnalités et options. Essayez-le dès aujourd'hui en définissant vos préférences et en cliquant sur \"Générer\" pour voir quels Pokémon vous attendent !",
      "Partagez vos résultats avec vos amis et d'autres dresseurs, et faites-nous savoir comment vous utilisez le Générateur de Pokémon Aléatoire dans votre aventure Pokémon. Bonne chasse !"
    ]
  },
  // Sections de contenu pour "Quel Pokémon suis-je"
  whichPokemonIntro: {
    content: [
      "Vous êtes-vous déjà demandé à quel Pokémon vous ressemblez le plus ? Notre outil \"Quel Pokémon suis-je\" offre une façon amusante et unique de découvrir votre homologue Pokémon basé sur vos caractéristiques physiques.",
      "Cette fonctionnalité innovante analyse votre taille et votre poids pour identifier le Pokémon qui correspond le plus étroitement à vos proportions. Que vous soyez aussi grand qu'un Dracaufeu ou aussi compact qu'un Pikachu, notre algorithme trouvera votre Pokémon correspondant parfait avec une précision surprenante."
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "L'utilisation de notre outil \"Quel Pokémon suis-je\" est simple et ne prend que quelques secondes. Suivez ces étapes faciles pour découvrir votre correspondance Pokémon :",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Entrez votre nom (ou surnom) dans le formulaire fourni." },
          { type: "text", content: "Saisissez votre taille en centimètres (cm)." },
          { type: "text", content: "Saisissez votre poids en kilogrammes (kg)." },
          { type: "text", content: "Cliquez sur le bouton \"Trouver mon Pokémon\" pour voir vos résultats." },
          { type: "text", content: "Consultez votre Pokémon correspondant, y compris son nom, son type, sa taille, son poids et son score de similarité." },
          { type: "text", content: "Partagez vos résultats sur les réseaux sociaux ou téléchargez-les sous forme d'image pour les montrer à vos amis !" }
        ]
      },
      "Le score de similarité indique à quel point vos proportions correspondent à celles du Pokémon. Plus le pourcentage est élevé, plus la correspondance est proche !"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "Découvrir votre homologue Pokémon offre bien plus qu'une simple valeur de divertissement :",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Une façon amusante d'apprendre : Découvrez et apprenez-en plus sur de nouveaux Pokémon qui correspondent à vos traits physiques." },
          { type: "text", content: "Perspective unique : Voyez-vous à travers le prisme du monde Pokémon." },
          { type: "text", content: "Démarreur de conversation : Partagez vos résultats avec des amis et comparez quel Pokémon correspond à chacun d'entre vous." },
          { type: "text", content: "Inspiration pour le cosplay : Trouvez un Pokémon qui correspond naturellement à votre type de corps pour des idées de cosplay." },
          { type: "text", content: "Construction d'équipe : Créez une équipe thématique dans les jeux Pokémon basée sur les similitudes physiques avec vous et vos amis." }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Quelle est la précision de l'algorithme de correspondance ?",
            answer: "Notre algorithme utilise les données officielles de taille et de poids des Pokémon de PokéAPI, calculant la similarité basée sur la distance euclidienne proportionnelle. Bien qu'il soit conçu pour le plaisir plutôt que pour une précision scientifique, de nombreux utilisateurs trouvent les correspondances étonnamment appropriées !"
          },
          {
            type: "faq",
            question: "Pourquoi l'outil ne prend-il pas en compte d'autres traits physiques ?",
            answer: "Actuellement, nous nous concentrons sur la taille et le poids pour plus de simplicité et parce que ce sont les attributs physiques les plus constamment documentés pour toutes les espèces de Pokémon. Nous pourrions envisager d'ajouter plus d'attributs dans de futures mises à jour."
          },
          {
            type: "faq",
            question: "Puis-je correspondre avec n'importe quel Pokémon ?",
            answer: "Actuellement, l'outil effectue des correspondances avec les 151 Pokémon originaux (Génération I) pour optimiser les performances. Nous prévoyons d'étendre cela pour inclure toutes les générations dans de futures mises à jour."
          },
          {
            type: "faq",
            question: "Mes données personnelles sont-elles sauvegardées ou partagées ?",
            answer: "Non, nous ne stockons pas votre taille, votre poids ni aucune autre information personnelle que vous saisissez. Tous les calculs sont effectués dans votre navigateur et rien n'est envoyé à nos serveurs."
          },
          {
            type: "faq",
            question: "Pourquoi ai-je correspondu à un Pokémon différent de mon ami qui a des mensurations similaires ?",
            answer: "De petites différences dans le rapport taille/poids peuvent conduire à des correspondances différentes. L'algorithme considère les proportions plutôt que les valeurs absolues."
          },
          {
            type: "faq",
            question: "Puis-je partager mes résultats sur les réseaux sociaux ?",
            answer: "Oui ! Vous pouvez télécharger votre résultat sous forme d'image ou le partager directement sur des plateformes comme Facebook et Twitter en utilisant les boutons fournis."
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "Notre outil \"Quel Pokémon suis-je\" offre un aperçu ludique de la façon dont vous pourriez exister dans le merveilleux monde des Pokémon. Bien qu'il soit principalement conçu pour le divertissement, de nombreux utilisateurs découvrent des connexions surprenantes avec la personnalité ou les capacités de leur Pokémon correspondant, au-delà des simples similitudes physiques.",
      "Essayez de modifier légèrement vos entrées pour voir comment différentes tailles et poids affectent vos correspondances, ou défiez vos amis et votre famille de trouver leurs homologues Pokémon. Vous pourriez être surpris par les paires de Pokémon résultantes !",
      "Que vous correspondiez à un majestueux Pokémon Légendaire, à un puissant starter, ou à un monstre de poche sous-estimé, embrassez votre homologue Pokémon et les qualités uniques que vous partagez. Après tout, dans le monde des Pokémon, chaque espèce a ses propres forces spéciales et son importance."
    ]
  }
}; 